import type { TReservaProduto } from '@/features/produtos/interfaces/produto.types'
import { HttpService } from '@/shared/lib'

export class PostReservaProdutoService extends HttpService {
  async execute(idExternoProduto: number, data: TReservaProduto) {
    return this.http.post(`/api/v2/ReservaDoProduto/${idExternoProduto}`, data)
  }
}
